import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import style from "../../assets/jss/disal-main/Layouts/Gerencia";
import { makeStyles } from "@material-ui/core/styles";
import { useGerencia } from "../../Context/GerenciaContext";

const useStyles = makeStyles(style);

const GerenciaForm = () => {
  const classes = useStyles();

  const { selected, setSelected, doSave } = useGerencia();

  const [form, setForm] = useState({
    id: "",
    name: "",
    outsoursing: -1,
    error: { name: "", outsoursing: "" }
  });

  useEffect(() => {
    if (selected) {
      setForm({
        id: selected.departmentId,
        name: selected.departmentDescription,
        outsoursing: selected.isOutsourcing,
        error: { name: "", outsoursing: "" }
      });
    }
  }, [selected]);


  const saveUpdate = (form) => {
    
    if (form.name === "") {
      setForm({ ...form, error: { name: "El nombre es obligatorio" } });
      return;
    }
    
    if (form.outsoursing === -1) {
      setForm({ ...form, error: { outsoursing: "Selecciona una opción" } });
      return;
    }

    doSave(form);
  }

  return (
    <div className={classes.contentForm}>
      <Grid container>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={3}>
                <label>ID </label>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  disabled
                  name="id"
                  variant="outlined"
                  value={form.id}
                  className={classes.textFielInput + " blocked-id"}
                  onChange={() => setForm({ ...form, id: selected.id })}
                />
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={3}>
                <label>Nombre </label>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  name="name"
                  variant="outlined"
                  inputProps={{
                    maxLength: 100
                  }}
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className={classes.textFielInput}
                />
                <p>
                  {form.error.name}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="inputs-form">
            <Grid container>
              <Grid item xs={3}>
                <label>Outsourcing </label>
              </Grid>
              <Grid item xs={9}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                >
                  <Select
                    name="outsoursing"
                    native={false}
                    value={form.outsoursing}
                    onChange={(e) => setForm({ ...form, outsoursing: e.target.value })}
                  >
                    <MenuItem value={-1}>Selecciona una opción</MenuItem>
                    <MenuItem value={1}>Sí</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </Select>
                </FormControl>
                <p>
                  {form.error.outsoursing}
                </p>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>

      <div className={classes.contentButton}>
        <button onClick={() => setSelected(null)}>Cancelar</button>
        <button onClick={() => saveUpdate(form)}>Guardar</button>
      </div>
    </div>
  );
}

export default GerenciaForm;

